module.exports = __webpack_public_path__ + "img/p-25.be3eaa96.jpg";